var _defs, _polygon, _polygon2, _g, _g2, _text, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 189 49.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        letter-spacing: .15em;\n      }\n\n      .cls-3 {\n        letter-spacing: .08em;\n      }\n\n      .cls-4 {\n        font-family: LEMONMILK-Light, 'LEMON MILK';\n        font-size: 24.39px;\n        font-weight: 300;\n      }\n\n      .cls-5 {\n        fill: url(#Sky);\n      }\n\n      .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke: #000;\n      }\n\n      .cls-5, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-width: 2.08px;\n      }\n\n      .cls-5, .cls-10 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n        stroke-width: 2.68px;\n      }\n\n      .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-11 {\n        letter-spacing: .11em;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-13 {\n        letter-spacing: .15em;\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.12,
    y1: -3956.86,
    x2: 62.73,
    y2: -3940.11,
    gradientTransform: "translate(0 -3910.45) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f5fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dceff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b2ddf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#78c3e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#30a4da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1e9cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0075be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005b97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -109.14,
    y1: -3956.86,
    x2: -81.53,
    y2: -3940.11,
    gradientTransform: "translate(-92.15 -3910.45) rotate(-180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 40.82,
    y1: 24.72,
    x2: 10.71,
    y2: 24.72,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sky",
    x1: 39.88,
    y1: 47.39,
    x2: 6.76,
    y2: 21.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cce0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c2dcf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a9d2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7fc2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#46abdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1e9cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0075be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005b97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 15.75,
    y1: 25.28,
    x2: 44.26,
    y2: 53.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#f5fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dceff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#b2ddf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#78c3e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#30a4da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1e9cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0075be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005b97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 20.54,
    y1: 20.49,
    x2: 49.06,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cce0f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#c2dcf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#a9d2ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#7fc2e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#46abdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1e9cd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0075be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#005b97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 17.73,
    y1: 23.3,
    x2: 46.25,
    y2: 51.81,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 24.99,
    y1: 16.04,
    x2: 53.51,
    y2: 44.55,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 21.17,
    y1: 19.86,
    x2: 49.69,
    y2: 48.37,
    xlinkHref: "#linear-gradient-5"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "36.37 49.01 30.42 45.59 46.17 36.34 52.11 39.76 36.37 49.01"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.75 49.01 21.69 45.59 5.95 36.34 0 39.76 15.75 49.01"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-10",
    points: "46.24 15.04 46.24 12.96 25.87 1.2 5.5 12.96 5.5 36.48 25.87 48.24 46.24 36.48 46.24 33.91"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 25.87,
    y1: 24.53,
    x2: 25.87,
    y2: 48.24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "25.87 24.72 25.87 40.35 12.33 32.54 12.33 16.91 12.34 16.91 25.87 24.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "39.4 16.91 39.4 40.43 25.87 48.25 25.87 24.72 39.37 16.89 39.4 16.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "35.25 32.15 35.25 41.23 30.02 44.25 30.02 35.17 35.23 32.14 35.25 32.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "39.37 16.89 25.87 24.72 12.34 16.91 25.87 9.09 39.37 16.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 25.87,
    y1: 24.72,
    x2: 25.87,
    y2: 24.39
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(57.15 33.59)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 0,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 21.02,
    y: 0
  }, "SS B"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 88.42,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 112.05,
    y: 0
  }, "X"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116.95,
    y: 22.21,
    width: 4.17,
    height: 4.17
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.261e087f31b21aade6cf2182af5b7bec.svg";
export { ForwardRef as ReactComponent };